import { ILiveGateway } from 'src/core/player/interfaces/LiveGateway';
import VideoJsGateway from './VideoJsGateway';

class VideoJsLiveGateway extends VideoJsGateway implements ILiveGateway {
  get liveTracker() {
    const liveTracker = this.videojsInstance.liveTracker;
    return {
      atLiveEdge: liveTracker.atLiveEdge(),
      seekableStart: liveTracker.seekableStart(),
      liveWindow: liveTracker.liveWindow(),
      liveCurrentTime: liveTracker.liveCurrentTime(),
      seekToLiveEdge: () => liveTracker.seekToLiveEdge(),
    };
  }
}

export default VideoJsLiveGateway;
